export default "__VITE_ASSET__BnV5KLi___"